export const REQUEST_INVOICES = 'payments/REQUEST_INVOICES';
export const REQUEST_USER_TRANSACTIONS = 'payments/REQUEST_USER_TRANSACTIONS';
export const REQUEST_SUBSCRIPTION_PLANS = 'payments/REQUEST_SUBSCRIPTION_PLANS';
export const REQUEST_CURRENT_CUSTOMER = 'payments/REQUEST_CURRENT_CUSTOMER';

export const REQUEST_CREATE_INVOICE = 'payments/REQUEST_CREATE_INVOICE';
export const REQUEST_GET_PAYMENT_METHODS = 'payments/REQUEST_GET_PAYMENT_METHODS';
export const REQUEST_CREATE_PAYMENT_METHOD = 'payments/REQUEST_CREATE_PAYMENT_METHOD';
export const REQUEST_DELETE_PAYMENT_METHOD = 'payments/REQUEST_DELETE_PAYMENT_METHOD';
export const REQUEST_SET_DEFAULT_PAYMENT_METHOD = 'payments/REQUEST_SET_DEFAULT_PAYMENT_METHOD';

export const REQUEST_PAYMENT_ATTEMPT = 'payments/REQUEST_PAYMENT_ATTEMPT';
export const REQUEST_PAYMENT_INTENTS_SETUP = 'payments/REQUEST_PAYMENT_INTENTS_SETUP';

export const REQUEST_SET_SUBSCRIPTION = 'payments/REQUEST_SET_SUBSCRIPTION';
export const REQUEST_UPDATE_SUBSCRIPTION = 'payments/REQUEST_UPDATE_SUBSCRIPTION';
export const CANCEL_SUBSCRIPTION_REQUEST = 'payments/CANCEL_SUBSCRIPTION_REQUEST';
export const ADD_CARD_REQUEST = 'payments/ADD_CARD_REQUEST';
export const DELETE_CARD_REQUEST = 'payments/DELETE_CARD_REQUEST';
export const SET_DEFAULT_CARD_REQUEST = 'payments/SET_DEFAULT_CARD_REQUEST';

export const SET_SUBSCRIPTION = 'payments/SET_SUBSCRIPTION';
export const UPDATE_SUBSCRIPTION = 'payments/UPDATE_SUBSCRIPTION';
export const SET_PAYMENT_STATE = 'payments/SET_PAYMENT_STATE';
export const ADD_CARD = 'payments/ADD_CARD';
export const DELETE_CARD = 'payments/DELETE_CARD';
export const SET_DEFAULT_CARD = 'payments/SET_DEFAULT_CARD';
